<template>
  <Content>
    <FlexContainer>
      <FlexItem size="25%" padding="normal" v-if="false">
        <Card>Filters</Card>
      </FlexItem>
      <FlexItem padding="normal" :grow="true">
        <Card>
          <h1>Add Publisher</h1>
          <PublisherForm :publisherId="id" />
        </Card>
      </FlexItem>
    </FlexContainer>
  </Content>
</template>

<script>
import { required, requiredIf, email } from 'vuelidate/lib/validators';
import { mapGetters, mapActions } from 'vuex';
import PublisherForm from '@/components/admin/PublisherForm';

export default {
  components: {
    PublisherForm
  },
  data: () => {
    return {
      id: null
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
    }
  }
};
</script>

<style lang="scss" scoped></style>
